<template>
  <div id="SchoolAssessment">
    <a-table v-if="schoolTask && schoolTask.length" bordered :dataSource="schoolTask" :columns="columns" :pagination="false" :rowKey="row => row.qid">
      <div slot="taskName" slot-scope="text">
        <img src="@/assets/desk3.png" alt="">
        <b style="font-weight: normal;">{{text}}</b>
      </div>
      <div slot="progress" slot-scope="text, record">
        <a-progress :percent="parseFloat(parseFloat(record.progress).toFixed(2))" :strokeWidth="6" />
        <span style="color: #595959">进行中</span>
      </div>
      <div slot="operation" slot-scope="text, record">
        <span style="color: #1890FF;cursor: pointer;" @click="viewUndetected(record)">查看未测</span>
      </div>
    </a-table>
    <div v-else class="noTask">
      <img src="@/assets/desk6.png" alt="">
      <span>暂无进行中的校内测评</span>
    </div>
    <div class="taskDetail" v-if="taskDetailData">
      <a-drawer
        wrapClassName="wrapModalUndetected"
        width="1000"
        :closable="false"
        :visible="visible"
        @close="close"
      >
        <modal-undetected :taskDetailData="taskDetailData" @close="close"></modal-undetected>
      </a-drawer>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import ModalUndetected from '@/components/Evaluation/Education/ModalUndetected'
export default {
  name: 'SchoolAssessment',
  data () {
    return {
      visible: false,
      taskDetailData: null,
      schoolTask: [],
      columns: [
        {
          title: '任务名称',
          dataIndex: 'taskName',
          width: '25%',
          scopedSlots: { customRender: 'taskName' },
        },
        {
          title: '任务进度',
          dataIndex: 'progress',
          width: '55%',
          scopedSlots: { customRender: 'progress' }
        },
        {
          title: '操作',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        },
      ]
    }
  },
  computed: {
    ...mapState([
      'schoolTaskScale',
      'schoolTaskGame'
    ])
  },
  components: {
    ModalUndetected
  },
  methods: {
    ...mapActions([
      'getSchoolTaskScale',
      // 'getSchoolTaskGame',
      'getUnfinishedStudents',
      'getGame'
    ]),
    close () {
			this.visible = false
		},
    async viewUndetected (item) { // 查看未测
      let gradeList = []
      let grade_list = []
      this.visible = true
      item.classAgg.map((item) => {
        grade_list.push(item.entryYear)
        gradeList.push({
          grade_id: item.entryYear,
          class_id: item.classId
        })
      })
      console.log(item)
      this.taskDetailData = {
        TASK_NAME: item.title,
        TASK_START_DATE: item.start_time,
        TASK_END_DATE: item.end_time,
        PROGRESS: item.progress,
        GRADE_LIST: grade_list.join(','),
        DQ_ID: item.qid,
        GROUP_TYPE: item.GROUP_TYPE
      }
      if (item) {
        if (item.GROUP_TYPE === 1) { // 量表
          let SURVEY_LIST = item.topics.split(',')
					sessionStorage.setItem('SURVEY_LIST', JSON.stringify(SURVEY_LIST))
          await this.getUnfinishedStudents({gradeList, item: this.taskDetailData})
        } else if (item.GROUP_TYPE === 2) { // 游戏
          await this.getGame()
        }
      }
    }
  },
  async mounted () {
    let schoolTasks = []
    this.schoolTask = []
    await this.getSchoolTaskScale()
    // await this.getSchoolTaskGame()
    this.schoolTaskScale.map((item) => {
			item.GROUP_TYPE = 1
		})
		// this.schoolTaskGame.map((item) => {
    //   item.GROUP_TYPE = 2
    //   item.progress = parseInt(item.progress) * 100
    // })
    // moment(parseInt(item.START_TIME.replace(/[^0-9]/ig, ''))).format('YYYY-MM-DD')
    schoolTasks = [...this.schoolTaskScale]
    schoolTasks.sort((a, b) => {
      return new Date(b.start_time.replace(/-/g, '/')) - new Date(a.start_time.replace(/-/g, '/'))
    })
    schoolTasks.map((item) => {
      item.taskName = item.title
      if (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(item.end_time.replace(/-/g, '/'))) {
        this.schoolTask.push(item)
      }
    })
  }
}
</script>

<style>
#SchoolAssessment {
  width: 100%;
}
.ant-card-small > .ant-card-body {
  padding: 0px;
}
#SchoolAssessment  .ant-table-tbody > tr:last-child > td {
  border: 0px;
}
#SchoolAssessment  .ant-table-thead > tr > th, #SchoolAssessment  .ant-table-tbody > tr > td {
  border-left: 0px;
  border-right: 0px;
  padding-left: 24px;
  font-size: 14px;
  color: #262626;
}
#SchoolAssessment  .ant-table-thead > tr > th {
  color: #8C8C8C;
  font-size: 12px;
}
#SchoolAssessment  .ant-table-tbody > tr > td > div {
  display: flex;
  align-items: center;
}
#SchoolAssessment  .ant-table-tbody > tr > td > div .ant-progress {
  width: 60%;
  margin-right: 50px;
}
#SchoolAssessment  .ant-table-tbody > tr > td img {
  margin-right: 12px;
}
#SchoolAssessment .noTask {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #8C8C8C;
  padding: 48px 0px 40px;
}
#SchoolAssessment .noTask img {
  width: 64px;
  height: auto;
  margin-bottom: 17px;
}
</style>
